import { ArrowRight } from "lucide-react";

export default function OpenSourcingStatement({ onEnquiry }) {
  return (
    <section data-testid="ugi-open-sourcing-container" className="border-y border-[#C5A059]/25 bg-[#EFEBE1]">
      <div className="relative mx-auto max-w-7xl overflow-hidden px-5 py-16 sm:px-8 lg:py-20">
        <div className="absolute inset-y-0 right-0 hidden w-1/2 opacity-[0.07] map-grid lg:block" aria-hidden="true" />
        <div className="relative grid gap-8 lg:grid-cols-[1fr_auto] lg:items-center">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#9B7437]">Open Sourcing</p>
            <h2 data-testid="open-sourcing-heading" className="mt-4 max-w-3xl font-serif text-3xl font-normal leading-tight tracking-[-0.02em] text-[#1C1613] sm:text-4xl">
              Looking for something else? Tell us what you need.
            </h2>
            <p className="mt-5 max-w-2xl text-base font-light leading-8 text-[#524842]">
              UGI remains open to sourcing opportunities beyond the current focus areas. Share your product, specification, destination market or category to begin the conversation.
            </p>
          </div>
          <button data-testid="open-sourcing-start-enquiry-cta" onClick={onEnquiry} className="group inline-flex items-center justify-center gap-3 border border-[#1C1613] bg-[#1C1613] px-7 py-4 text-xs font-bold tracking-[0.16em] text-[#FDFBF7] transition-colors hover:bg-transparent hover:text-[#1C1613] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
            START AN ENQUIRY
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
}
